import { create } from 'zustand';
import { SubscriptionStore } from './subscriptionStore';

export const useSubscriptionStore = create<SubscriptionStore>()((set) => ({
    currentPlan: null,
    isLoading: true, // Start with true to prevent flash of SubscriptionPrompt before plan is fetched
    error: null,
    setCurrentPlan: (plan) =>
        set({
            currentPlan: plan,
            error: null, // Clear any previous errors
        }),
    setLoading: (loading) =>
        set({
            isLoading: loading,
        }),
    setError: (error) =>
        set({
            error,
            isLoading: false,
        }),
    clearSubscription: () =>
        set({
            currentPlan: null,
            isLoading: false,
            error: null,
        }),
}));